import React from 'react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import GetfVDateFormate from '../../../utils/Genaricfunctions';


import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { string } from 'yup';
import CloseIcon from '@mui/icons-material/Close';
import RestoreIcon from '@mui/icons-material/Restore';


export default function SupportingDocumentEdit({
    history,
    HistoryClose,
    DocName
}) {


    return (
        <>
            <DialogTitle id="responsive-dialog-title" className='text-center' >
                <span style={{ fontSize: "20px" }}> {DocName}</span> <span style={{ float: "right", color: "red", cursor: "pointer", }}><CloseIcon onClick={HistoryClose} /></span>
            </DialogTitle>
            <DialogContent >
                <DialogContentText>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 1000 }} aria-label="simple table">
                            <TableHead>
                                <TableRow sx={{ backgroundColor: "#F2F4F7", color: "#667085" }}>
                                    <TableCell style={{ fontSize: "13px", color: "#667085" }}>Name</TableCell>
                                    <TableCell style={{ fontSize: "13px", color: "#667085" }}>type</TableCell>
                                    <TableCell style={{ fontSize: "13px", color: "#667085" }}>Expiration </TableCell>
                                    <TableCell style={{ fontSize: "13px", color: "#667085" }}>Status</TableCell>
                                    <TableCell style={{ fontSize: "12px", color: "#667085" }}>Changed By </TableCell>
                                    <TableCell style={{ fontSize: "13px", color: "#667085" }}>Changed </TableCell>
                                    <TableCell style={{ fontSize: "13px", color: "#667085" }}>Activity</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {history?.map((row) => (
                                    <TableRow
                                        key={row?.modifiedOn}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell style={{ fontSize: "13px" }}>{row?.documentName}</TableCell>
                                        <TableCell style={{ fontSize: "13px" }}>{row?.documentType}</TableCell>
                                        <TableCell style={{ fontSize: "13px" }}>{row?.expirationDate != null ? GetfVDateFormate("", row?.expirationDate) : row?.expirationDate}</TableCell>
                                        <TableCell style={{ fontSize: "13px" }}>{row?.status}</TableCell>
                                        <TableCell style={{ fontSize: "13px" }}>{row?.modifiedBy}</TableCell>
                                        <TableCell style={{ fontSize: "13px" }}>{row?.modifiedOn != null ? GetfVDateFormate("", row?.modifiedOn) : row?.modifiedOn}</TableCell>
                                        <TableCell style={{ fontSize: "13px" }}>{row?.modificationType}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContentText>
            </DialogContent>
        </>
    )
}